import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_URL}`;

// Get token from localStorage
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication token not found. Please log in again.');
  }
  return { Authorization: `Bearer ${token}` };
};


export const fetchStudentRecords = async (
  page = 1,
  limit = 10,
  search = '',
  searchField = 'name',
  filters = {},
  dueToday = false,
  todaysAdmission = false,
  dateRange = {},
  pendingFeesList = false,
  pendingFeesOverdue = false // Add this parameter
) => {
  try {
    // Get auth token from localStorage
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Build query parameters
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });

    // Add search parameter if available
    if (search) {
      params.append("search", search);
      params.append("searchField", searchField);
    }

    // Add dueToday flag if true
    if (dueToday) {
      params.append("dueToday", "true");
    }

    if (pendingFeesList) {
      params.append("pendingFeesList", "true");
    }

    // Add pendingFeesOverdue flag if true
    if (pendingFeesOverdue) {
      params.append("pendingFeesOverdue", "true");
    }

    // Add todaysAdmission flag if true
    if (todaysAdmission) {
      params.append("todaysAdmission", "true");
    }

    // Add date range if provided
    const { fromDate, toDate } = dateRange;
    if (fromDate) {
      params.append("fromDate", fromDate);
    }
    if (toDate) {
      params.append("toDate", toDate);
    }

    // Add filters
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    // Make the request
    const response = await fetch(
      `${API_BASE_URL}/completedCourse?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();

    return {
      completedStudents: data?.completedStudents ?? [],
      totalPages: data?.totalPages ?? 0,
      totalStudents: data?.totalStudents ?? 0,
      totalRecords: data.totalStudents // Make sure this is included in your API response

    };
  } catch (error) {
    console.error("Error fetching student records:", error);
    throw error;
  }
};




// Update student payment information
export const updateStudentPayment = async (studentId, updateData) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/registrations/${studentId}`,
      updateData,
      { headers: getAuthHeader() }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating student payment:", error);
    throw error;
  }
};

// Get current employee details
export const getCurrentEmployee = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/regdetail`,
      { headers: getAuthHeader() }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching employee details:", error);
    throw error;
  }
};

export const fetchAllStudentRecords = async (
  search = '',
  searchField = 'name',
  filters = {},
  dueToday = false,
  todaysAdmission = false,
  dateRange = {},
  pendingFeesList = false,
  pendingFeesOverdue = false // Add this parameter
) => {
  try {
    // Get auth token from localStorage
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Build query parameters - no pagination for export
    const params = new URLSearchParams({
      page: 1,
      limit: 999999, // Set a very high limit to get all records
      export: 'true' // Add export flag to indicate this is for export
    });

    // Add search parameter if available
    if (search) {
      params.append("search", search);
      params.append("searchField", searchField);
    }

    // Add dueToday flag if true
    if (dueToday) {
      params.append("dueToday", "true");
    }

    if (pendingFeesList) {
      params.append("pendingFeesList", "true");
    }

    // Add pendingFeesOverdue flag if true
    if (pendingFeesOverdue) {
      params.append("pendingFeesOverdue", "true");
    }

    // Add todaysAdmission flag if true
    if (todaysAdmission) {
      params.append("todaysAdmission", "true");
    }

    // Add date range if provided
    const { fromDate, toDate } = dateRange;
    if (fromDate) {
      params.append("fromDate", fromDate);
    }
    if (toDate) {
      params.append("toDate", toDate);
    }

    // Add filters
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    // Make the request
    const response = await fetch(
      `${API_BASE_URL}/completedCourse?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();

    return {
      registrations: data?.registrations ?? [],
      totalRegistrations: data?.totalRegistrations ?? 0,
    };
  } catch (error) {
    console.error("Error fetching all student records:", error);
    throw error;
  }
};
